import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { ViewsComponent } from "./views/views.component";
import { AuthGuard } from "./_helpers/auth.guard.service";
import { TermsConditionsComponent } from "./views/terms-conditions/terms-conditions.component";
import { TermsPolicyComponent } from "./views/terms-policy/terms-policy.component";
import { PrivacyPolicyComponent } from "./views/privacy-policy/privacy-policy.component";
import { OurMissionComponent } from "./views/our-mission/our-mission.component";

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },

  { path: "", redirectTo: "auth", pathMatch: "full" },
  // {
  //   path: "edit-profile",
  //   component: EditProfileComponent,
  // }, 
  {
    path: "terms-conditions/Redirection",
    component: TermsConditionsComponent,
  },
  {
    path: "terms-policy/Redirection",
    component: TermsPolicyComponent,
  },
  {
    path: "privacy-policy/Redirection",
    component: PrivacyPolicyComponent,
  },
  {
    path: "our-mission/Redirection",
    component: OurMissionComponent,
  },
  {
    path: "",
    component: ViewsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "change-password", component: EditProfileComponent },

      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },

      {
        path: "analytics-dashboard",
        loadChildren: () =>
          import("../app/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          )
      },

      // {
      //   path: "manage-guest",
      //   loadChildren: () =>
      //     import("../app/views/manage-guest/manage-guest.module").then(
      //       (m) => m.ManageGuestModule
      //     )
      // },

      {
        path: "manage-guest",
        loadChildren: () =>
          import("../app/views/manage-guest/manage-guest.module").then(
            (m) => m.ManageGuestModule
          )
      },

      {
        path: "manage-host",
        loadChildren: () =>
          import("../app/views/manage-host/manage-host.module").then(
            (m) => m.ManageCaregiversModule
          )
      },

      
      {
        path: "email-template",
        loadChildren: () =>
          import("../app/views/manage-email/manage-email.module").then(
            (m) => m.ManageEmailModule
          )
      },

      {
        path: "manage-report",
        loadChildren: () =>
          import("../app/views/manage-reported/manage-reported.module").then(
            (m) => m.ManageReportedModule
          )
      },

    

      {
        path: "manage-problem",
        loadChildren: () =>
          import("../app/views/manage-problem/manage-problem.module").then(
            (m) => m.ManageProblemModule
          )
      },


      {
        path: "terms-conditions",
        loadChildren: () =>
          import("../app/views/terms-conditions/terms-conditions.module").then(
            (m) => m.TermsConditionsModule
          )
      },

      {
        path: "our-mission",
        loadChildren: () =>
          import("../app/views/our-mission/our-mission.module").then(
            (m) => m.OurMissionModule
          )
      },

      {
        path: "privacy-policy",
        loadChildren: () =>
          import("../app/views/privacy-policy/privacy-policy.module").then(
            (m) => m.PrivacyPolicyModule
          )
      },

      {
        path: "terms-policy",
        loadChildren: () =>
          import("../app/views/terms-policy/terms-policy.module").then(
            (m) => m.TermsPolicyModule
          )
      },
     

    ],
  },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
